export default "__VITE_ASSET__DkBraZBP__"